import { ref } from "vue";
import Pusher from "pusher-js";
import {
    EXPO_PUBLIC_REVERB_KEY,
    EXPO_PUBLIC_REVERB_HOST,
    EXPO_PUBLIC_REVERB_PORT,
    EXPO_PUBLIC_REVERB_AUTH_URL,
    REVERB_APP_CLUSTER,
} from "@/shared/constants/env";
import { PusherEvents } from "@/shared/constants/PusherEvents";

let pusherInstance: Pusher | null = null;
const isConnected = ref(false);

export function usePusher() {
    const initPusher = (userId: number, token: string) => {
        if (pusherInstance || !EXPO_PUBLIC_REVERB_KEY) return;

        pusherInstance = new Pusher(EXPO_PUBLIC_REVERB_KEY, {
            cluster: REVERB_APP_CLUSTER,
            wsHost: EXPO_PUBLIC_REVERB_HOST,
            wssPort: EXPO_PUBLIC_REVERB_PORT,
            forceTLS: true,
            enabledTransports: ["ws", "wss"],
            channelAuthorization: {
                endpoint: EXPO_PUBLIC_REVERB_AUTH_URL,
                transport: "ajax",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        });

        pusherInstance.connection.bind("connected", () => {
            isConnected.value = true;
            console.log("Pusher connected");
        });

        pusherInstance.connection.bind("disconnected", () => {
            isConnected.value = false;
            console.log("Pusher disconnected");
        });

        // Subscribe to channels
        const channelUser = pusherInstance.subscribe(`private-user.${userId}`);
        const channelEveryone = pusherInstance.subscribe("private-everyone");
        const channelOrders = pusherInstance.subscribe("orders");

        // User messages - dynamic import to avoid circular dependency
        channelUser.bind(PusherEvents.TextToUser, (data: any) => {
            console.log("User message:", data);
            import("@/modules/notifications/stores/notifications").then(({ useNotificationStore }) => {
                const notificationStore = useNotificationStore();
                notificationStore.show(data.payload.message, "message");
            });
        });

        // Broadcast messages
        channelEveryone.bind(PusherEvents.TextToEveryone, (data: any) => {
            console.log("Broadcast message:", data);
            import("@/modules/notifications/stores/notifications").then(({ useNotificationStore }) => {
                const notificationStore = useNotificationStore();
                notificationStore.show(data.payload.message, "message");
            });
        });

        // Order events
        channelOrders.bind(PusherEvents.OrderPaid, (data: any) => {
            console.log("Order paid:", data);
            // Handle order paid event
        });

        // Fetch last notifications
        import("@/modules/notifications/stores/notifications").then(({ useNotificationStore }) => {
            const notificationStore = useNotificationStore();
            notificationStore.fetchLastPushes();
        });
    };

    const disconnectPusher = () => {
        if (pusherInstance) {
            pusherInstance.unbind_all();
            pusherInstance.disconnect();
            pusherInstance = null;
            isConnected.value = false;
        }
    };

    const subscribeToTables = (callback: (data: any) => void) => {
        if (!pusherInstance) return;

        const channel = pusherInstance.subscribe("private-tables");
        channel.bind(PusherEvents.StaleBusyTable, callback);
    };

    return {
        initPusher,
        disconnectPusher,
        subscribeToTables,
        isConnected,
    };
}